import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ebe5116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "scrollable-content" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "dotation-header" }
const _hoisted_5 = { class: "dotation-icon" }
const _hoisted_6 = { class: "dotation-details" }
const _hoisted_7 = { class: "dotation-title" }
const _hoisted_8 = { class: "dotation-subtitle" }
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = { class: "form-card" }
const _hoisted_11 = { class: "year-selector" }
const _hoisted_12 = { class: "action-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "text-selectable modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'gift'] })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t("settings-page.send-dotations")), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("settings-page.dotations-description")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("settings-page.select-year")), 1),
                _createVNode(_component_ion_select, {
                  modelValue: _ctx.selectedYear,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
                  interface: "action-sheet",
                  placeholder: _ctx.t('settings-page.select-year')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (year) => {
                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                        key: year,
                        value: year
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(year), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            class: "primary-action",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSend())),
            disabled: _ctx.sendInProgress
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'paper-plane'],
                class: "button-icon"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.send")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}